import { html, LitElement } from 'lit';

class FitLazyRender extends LitElement {

  static get is() {
    return 'fit-lazy-render';
  }

  render() {
    return html`<slot id="slot"></slot>`;
  }

  connectedCallback() {
    super.connectedCallback();
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.renderTemplates();
        this.intersectionObserver.disconnect();
      }
    });
    this.intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect()
    super.disconnectedCallback();
  }

  renderTemplates() {
    this.templates.forEach((template) => {
      const fragment = document.importNode(template.content, true);
      template._instances = Array.prototype.slice.call(fragment.children);
      template.parentNode.insertBefore(fragment, template);
    });
  }

  /**
   * @return {HTMLTemplateElement[]}
   */
  get templates() {
    const slot = this.shadowRoot.querySelector('#slot');
    return slot.assignedNodes({ flatten: true }).filter((node) => node.tagName === 'TEMPLATE');
  }
}

customElements.define(FitLazyRender.is, FitLazyRender);
